<template>
  <div
    class="navigation fixed top-0 left-0 w-308 flex justify-start items-start z-10 lg:w-180"
    style="height:80vh"
  >
    <div class="w-full flex flex-col">
      <div class="ml-12 border-l border-white border-dashed border-opacity-50">
        <div class="flex flex-col">
          <div
            class="flex flex-row justify-start items-center -ml-2 mt-10 first:mt-56 lg:first:mt-32"
            v-for="(nav, index) in navData"
            :key="index"
          >
            <span
              v-show="activeSection + 1 === nav.anchor"
              class="dot block w-2 h-2 transform rotate-45 m-1 bg-pale-orange"
            ></span>
            <span
              v-show="activeSection + 1 != nav.anchor"
              class="dot block w-2 h-2 transform rotate-45 m-1 bg-transparent"
            ></span>
            <div
              :class="
                activeSection + 1 === nav.anchor ? 'navActive' : 'navInactive'
              "
              class=" ml-3 font-rajdhani text-sm text-shadow-nav-title tracking-wide uppercase cursor-pointer hover:text-pale-orange"
              v-html="nav.title"
              @click="moveTo(nav.anchor)"
            ></div>
          </div>
        </div>
      </div>
      <div class="ml-12 relative w-20 h-16 flex items-end justify-center">
        <div class="icon-scroll"></div>
        <span
          class="absolute -bottom-4 -left-4 font-rajdhani text-sm text-white"
          >scroll</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeSection: Number,
    moveTo: Function,
  },
  data: function() {
    return {
      navData: [
        {
          title: 'Story',
          anchor: 3,
        },
        {
          title: 'classes',
          anchor: 4,
        },
        {
          title: 'Dungeons',
          anchor: 5,
        },
        {
          title: 'Legend Skills',
          anchor: 6,
        },
        {
          title: 'Champions',
          anchor: 7,
        },
        {
          title: 'Summonables',
          anchor: 8,
        },
        {
          title: 'Stats Upgrade',
          anchor: 9,
        },
        {
          title: 'Companions',
          anchor: 10,
        },
        {
          title: 'Combat Content',
          anchor: 11,
        },
      ],
    };
  },
};
</script>

<style lang="postcss">
.navInactive {
  @apply text-light-gray;
}
.navActive {
  @apply text-pale-orange;
}
</style>
